export default __webpack_public_path__ + "static/media/argentan10.f85e8b73.jpg";